<template>
  <c-box :mx="{ base: '-15px', md: '0' }">
    <c-heading as="h1" size="lg" :mt="{ base: '3xl', sm: '3rem', md: '4xl' }">
      {{ $t("logout.message.logout") }}
    </c-heading>
    <c-box d="none">
      <iframe id="logoutExtranet" v-chakra width="1px" height="1px" src=""></iframe>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import config from "@/config";
import { CBox, CHeading } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Logout",
  components: {
    CBox,
    CHeading,
  },

  mounted() {
    this.$nextTick(() => {
      (document.getElementById("logoutExtranet") as any).src = config.get("extranetUrlForLogout");
      this.$store.commit("iframes/closeAcademyWindow");
      setTimeout(
        // Give time for 3rd party logout processes to finish before iDBP logout
        () => {
          this.$store.dispatch("logout").then(() => {
            // tslint:disable-next-line:max-line-length
            window.location.href = `${config.get("adLogoutAddressWithoutRedirectUri")}${
              window.location.protocol
            }//${window.location.host}/`;
          });
        },
        1500
      );
    });
  },
});
</script>

<style lang="scss">
.invisible {
  display: none;
}

iframe.logout {
  width: 1px;
  height: 1px;
}
</style>
